import { apiGateway } from "@/_old/services/api-gateway";
import {
  CreateGroupParams,
  CreateGroupResponse,
  GetGroupsParams,
  GetGroupsResponse,
} from "@/company/groups/types";

const getGroups = async (
  params: GetGroupsParams,
  signal?: AbortSignal,
): Promise<GetGroupsResponse> => {
  const filters = params.filters?.reduce(
    (acc, filter) => {
      acc[filter.id] = filter.value;
      return acc;
    },
    {} as Record<string, string>,
  );

  const { data, total, count, totalPages } = await apiGateway
    .get(`/companies/${params.companyId}/groups`, {
      params: {
        ...Object.fromEntries(
          Object.entries(params).filter(
            ([key]) => key !== "filters" && key !== "companyId",
          ),
        ),
        ...filters,
      },
      signal,
    })
    .then((res) => {
      return {
        data: res.data.groups,
        total: res.data.total,
        count: res.data.take,
        totalPages: res.data.totalPages,
      };
    });

  return { data, total, count, totalPages } as unknown as GetGroupsResponse;
};

const createGroup = async (
  params: CreateGroupParams,
  signal?: AbortSignal,
): Promise<CreateGroupResponse> => {
  const {
    status,
    message,
    group: data,
  }: {
    status: number;
    message: string;
    group: CreateGroupResponse;
  } = await apiGateway.post(
    `/companies/${params.companyId}/groups`,
    {
      companyId: params.companyId,
      name: params.name,
      isActive: true,
    },
    {
      signal,
    },
  );

  if (status !== 200 && status !== 201) {
    throw new Error(message);
  }

  return data;
};

export { createGroup, getGroups };
